import React, { Component } from "react";
import GenericError from "./GenericError";

class ErrorBoundary extends Component {
    static defaultProps = {
        silent: false,
    };

    constructor() {
        super();
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    // Ensure React doesn't rethrow the error to the test runner in React 18
    componentDidCatch(error, info) {
        // Optionally log error details; keep silent by default here
        if (this.props.silent) {
            return;
        }
        // eslint-disable-next-line no-console
        console.log(error, info);
    }

    render() {
        if (this.state.hasError) {
            if (this.props.silent) {
                return <div></div>;
            }

            return (
                <GenericError
                    title="Something went wrong"
                    message="This incident has been reported and will be investigated. If it persists please let us know."
                />
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
